import { GenIcon } from 'react-icons';
export const MdCurrencyFlagCad = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_36362)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M3.05865 4.00656V19.9937C1.15477 17.8723 -0.00134277 15.0695 -0.00134277 11.9988C-0.00134277 8.92811 1.15742 6.13057 3.05865 4.00391V4.00656Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M20.9414 4.00937V19.9938C18.7432 22.4519 15.5479 24.0005 12 24.0005C8.45215 24.0005 5.25693 22.4519 3.05872 19.9938V4.00672C5.25693 1.55124 8.45215 0 12 0C15.5479 0 18.7432 1.55124 20.9414 4.00937Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M24.0013 12C24.0013 15.0681 22.8425 17.8682 20.944 19.9949V4.00781C22.8452 6.13182 24.0013 8.93202 24.0013 12Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M15.6142 14.7836L18.9977 12.0338L18.2102 11.6943C18.0988 11.6493 18.0405 11.5273 18.0723 11.4106L18.7007 9.16197L16.6669 9.59685C16.537 9.62337 16.4124 9.54382 16.3806 9.41654L16.1605 8.46192L14.5165 10.2889C14.3176 10.509 13.9543 10.3234 14.0126 10.0344L14.7684 6.32731L13.6706 6.88947C13.5088 6.97167 13.31 6.91068 13.2225 6.74893L12.0001 4.48438L10.7776 6.74893C10.6875 6.91068 10.4913 6.97167 10.3269 6.88947L9.22909 6.32731L9.98481 10.0344C10.0458 10.3261 9.68252 10.5117 9.48365 10.2889L7.83698 8.46192L7.61689 9.41654C7.58772 9.54382 7.46044 9.62337 7.33317 9.59685L5.2967 9.16197L5.92514 11.4106C5.95696 11.5273 5.89863 11.6466 5.78991 11.6943L4.99707 12.0338L8.38056 14.7836C8.53436 14.9109 8.59269 15.115 8.52905 15.3033L8.22412 16.1757L11.5042 15.7435C11.6633 15.7223 11.8065 15.8496 11.8012 16.0113L11.7031 19.5195H12.2864L12.1883 16.0113C12.1857 15.8496 12.3262 15.7223 12.4853 15.7435L15.768 16.1757L15.4631 15.3033C15.3968 15.115 15.4551 14.9109 15.6089 14.7836H15.6142Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_36362' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
